import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NetworkStatusService } from '../services/network-status.service';
import { isOfflineCapableNative } from '../commons/utils/platform';

// Blocks routes that require a live connection (shipments, inventory, reports, admin, and the
// public share-viewer routes) when the device is offline — redirects to a clear "not available
// offline" page with a returnUrl instead of letting the route load and fail confusingly
// mid-page (blank tables, generic error toasts). Transport Units, Business Partners, Products,
// and Loading Sites are deliberately NOT gated here — those work offline by design.
// Native-mobile only (Android/iOS): the web build never caches anything offline, so this guard
// is a no-op there and a plain failed request/normal error toast is what a web user sees instead.
@Injectable({
  providedIn: 'root',
})
export class OfflineGuard implements CanActivate {
  constructor(
    private networkStatusService: NetworkStatusService,
    private router: Router,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!isOfflineCapableNative()) return true;
    if (!this.networkStatusService.isOnline) {
      return this.router.createUrlTree(['/offline-unavailable'], {
        queryParams: { returnUrl: state.url },
      });
    }
    return true;
  }
}
